import React from 'react';
import styled from 'styled-components';

const Progress = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  ${props => `
    width: ${props.percentage}%;
    background: ${props.color};
  `}
`

const Bar = styled.div`
  position: relative;
  height: 5px;
  width: 100%;
  border-radius: 5px;
  overflow: hidden;
  background: #f1f1f1;
`;

const ProgressBar = ({
  progress,
  color,
}) => (
  <Bar>
    <Progress percentage={progress} color={color} />
  </Bar>
)

export default ProgressBar;


// WEBPACK FOOTER //
// ./src/components/common/progress-bar.js